import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import * as S from '../../styles';
import { MediumNavigationTab } from './components/medium';
import { getNavigationIcon } from 'console/navigation/icons';
export const MediumNavigationTabs = memo(function MediumNavigationTabs(props) {
    const { handles } = props;
    const onWheelTabs = useCallback((event) => {
        event.currentTarget.scrollLeft += event.deltaY;
    }, []);
    const tabs = useMemo(() => handles.map(({ selected, iconclass, icon, title, onClick, data_tooltip }, i) => (_jsx(MediumNavigationTab, { selected: selected, iconclass: iconclass, icon: icon ?? getNavigationIcon(iconclass), title: title, onClick: onClick, data_tooltip: data_tooltip }, i))), [handles]);
    return (_jsx(S.MediumNavigationTabs, { onWheel: onWheelTabs, "data-tooltip": "navigation-bar", children: tabs }));
});
